function IDEsSection() {
    return (
        <section class="ides-section">
            <div class="container">
                <p class="ides-label">Works seamlessly with</p>
                <div class="ides-grid">
                    <div class="ide-badge">VS Code</div>
                    <div class="ide-badge">Cursor</div>
                    <div class="ide-badge">Windsurf</div>
                    <div class="ide-badge">Antigravity</div>
                </div>
            </div>
        </section>
    );
}

export default IDEsSection;
